"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const groupBatchItem_1 = __importDefault(require("./groupBatchItem"));
const calculateLocalBatchItem_1 = __importDefault(require("./calculateLocalBatchItem"));
function formatSummary(appOrder, setting, includeCancelled = false) {
    const items = [];
    appOrder.batches.forEach((batch) => {
        batch.items.forEach((item) => {
            var _a;
            if (setting.receiptGroupBy === 'item') {
                if (!item.cancelled || includeCancelled) {
                    (_a = item.ids) === null || _a === void 0 ? void 0 : _a.forEach((i, index) => {
                        console.log('formatSummary', item);
                        items.push(Object.assign(Object.assign({}, item), { createdAt: batch.createdAt, batchId: batch.id, quantity: 1, id: i, total: item.prices[index], totalDiscount: item.totalDiscount / item.quantity }));
                    });
                }
            }
            else {
                if (!item.cancelled || includeCancelled) {
                    items.push(Object.assign(Object.assign({}, item), { createdAt: batch.createdAt, batchId: batch.id }));
                }
            }
        });
    });
    let orderedItems = [];
    if (setting.sortReceiptItemByCategory) {
        orderedItems = lodash_1.default.orderBy(items, ['categoryId', 'menuId'], ['asc', 'asc']);
    }
    else {
        orderedItems = items;
    }
    let summary;
    if (setting.receiptGroupBy === 'item') {
        summary = orderedItems.map(orderedItem => {
            const calculateItem = (0, calculateLocalBatchItem_1.default)(orderedItem, appOrder);
            const total = calculateItem.total + calculateItem.totalDiscount;
            return {
                id: calculateItem.id,
                menuId: calculateItem.menuId,
                name: calculateItem.name,
                quantity: calculateItem.quantity,
                unitPrice: total / orderedItem.quantity,
                price: total,
                items: calculateItem.setItems,
                options: calculateItem.options,
                remarks: calculateItem.remarks,
                excludeOrderDiscount: calculateItem.excludeOrderDiscount,
                excludedOrderSurcharge: calculateItem.excludedOrderSurcharge,
                cancelled: calculateItem.cancelled,
                cancelReason: calculateItem.cancelReason,
                isSet: calculateItem.isSet,
            };
        });
    }
    else {
        const groupByBatch = (setting.receiptGroupBy === 'batch');
        const groupBatchItems = (0, groupBatchItem_1.default)(orderedItems, undefined, undefined, true, groupByBatch);
        summary = groupBatchItems.map(groupBatchItem => {
            var _a;
            const calculateItem = (0, calculateLocalBatchItem_1.default)(groupBatchItem, appOrder);
            const total = (_a = calculateItem.totalWithoutDiscountModifiers) !== null && _a !== void 0 ? _a : calculateItem.total;
            return {
                id: calculateItem.id,
                batchId: calculateItem.batchId,
                menuId: calculateItem.menuId,
                name: calculateItem.name,
                quantity: calculateItem.quantity,
                unitPrice: total / groupBatchItem.quantity,
                price: total,
                items: calculateItem.setItems,
                options: calculateItem.options,
                remarks: calculateItem.remarks,
                excludeOrderDiscount: calculateItem.excludeOrderDiscount,
                excludedOrderSurcharge: calculateItem.excludedOrderSurcharge,
                cancelled: calculateItem.cancelled,
                cancelReason: calculateItem.cancelReason,
                totalWithoutSetItems: calculateItem.totalWithoutSetItems,
                isSet: calculateItem.isSet,
            };
        });
    }
    return summary;
}
exports.default = formatSummary;
//# sourceMappingURL=formatSummary.js.map